import { render } from "./Buoy.vue?vue&type=template&id=43be08d1"
import script from "./Buoy.vue?vue&type=script&lang=js"
export * from "./Buoy.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__